module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7696a504b61394f1d39fd510d22ee064.gif";